/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import Regex from './Regex'
import Errors from './ErrorStrings'

const validate = (field, value) => {
  switch (field) {
    case 'phoneNumber': {
      const regex = new RegExp(`^${Regex[field]}{10}$`)
      if (value === '') {
        return Errors[field].empty
      }
      if (value.toString().length !== 10) {
        return Errors[field].length
      }
      if (value.toString().match(regex) === null) {
        return Errors[field].valid
      }
      return null
    }

    case 'otp': {
      const regex = new RegExp(`^${Regex[field]}{4}$`)
      if (value === '') {
        return Errors[field].empty
      }
      if (value.toString().match(regex) === null) {
        return Errors[field].valid
      }
      if (value.toString().length !== 4) {
        return Errors[field].length
      }
      return null
    }
    case 'flatNumber':
    case 'buildingName':
    case 'localityName':
    case 'addressType':
    case 'streetName' :
    case 'selectedAddressType':
    case 'firstName':
    case 'lastName': {
      if (value.trim() === '') {
        return Errors[field].empty
      }
      return null
    }

    case 'pinCode': {
      const regex = new RegExp(`^${Regex[field]}{6}$`)
      if (value === '') {
        return Errors[field].empty
      }
      if (value.toString().length !== 6) {
        return Errors[field].length
      }
      if (value.toString().match(regex) === null) {
        return Errors[field].valid
      }
      return null
    }

    case 'email': {
      const regex = new RegExp(Regex.email)
      const strValue = String(value || '').toLowerCase()

      if (!strValue) {
        return Errors[field].invalid
      }

      if (!regex.test(strValue)) {
        return Errors[field].invalid
      }

      return null
    }
    default: return null
  }
}

export const validateRegex = (field, value) => {
  switch (field) {
    case 'phoneNumber': {
      const regex = new RegExp(`^${Regex[field]}{0,10}$`)
      return value.toString().match(regex)
    }
    case 'otp': {
      const regex = new RegExp(`^${Regex[field]}{0,4}$`)
      return value.toString().match(regex)
    }
    case 'pinCode': {
      const regex = new RegExp(`^${Regex[field]}{0,6}$`)
      return value.toString().match(regex)
    }
    default: return true
  }
}

const validateForm = (currentErrors, fieldsObj) => {
  const errors = currentErrors
  const fields = Object.keys(fieldsObj)
  fields.forEach((field) => {
    const error = validate(field, fieldsObj[field])
    if (error) {
      errors[field] = error
    } else {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete errors[field]
    }
  })
  return errors
}

export default validateForm
